<template>
<div :class='this.$vuetify.breakpoint'>
  <v-layout :class="{'pt-0' : $vuetify.breakpoint.xsOnly, 'pt-5 mt-5' : !$vuetify.breakpoint.xsOnly}">
    <v-flex xs12 sm11 offset-sm1>
      <v-layout row v-if="error">
        <v-flex xs12>
          <app-alert @dismissed="onDismissed" :text="error.message" :color="error.colour"></app-alert>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
            <form @submit.prevent="onSaveEmail">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading">Billing overview</span>
                </v-flex>
              </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 pb-3 v-if="group.subscription.status === 'pastDue'">
                    <v-alert
                      :value="true"
                      type="error"
                      >
                      <p>We tried to bill your account, but there is a problem with your payment method.</p>
                      <p>We'll retry the card over the next few days but to avoid any loss of service please take a moment to update your payment details in the <a :href='`/create-customer-portal-session?c=${group.stripeId}`'>Manage Billing</a> area'.</p>
                      <p>If you have any questions please contact us at <a class="white--text" href="mailto:support@tryworktabs.com">support@tryworktabs.com</a>.</p>
                    </v-alert>
                  </v-flex>
                  <v-flex xs12 v-if="group.subscription.status !== 'active' && group.subscription.status !== 'pastDue'">
                    <p>You have {{formatDateDifferenceInDays(group.subscription.current_period_end)}} days left on your free trial.</p>
                  </v-flex>
                  <v-flex xs12 v-else>
                    <p><strong>Subscription status:</strong><span class="flcaps">{{ group.subscription.status}}</span><br>
                    <strong>Next payment due:</strong> {{formatDate(group.subscription.current_period_end)}}<br>
                    <strong>Level:</strong><span class="flcaps">{{group.subscription.access.level}}</span><br>
                    </p>
                    <v-btn block depressed color="primary" :href='`/create-customer-portal-session?c=${group.stripeId}`'>
                      Manage billing
                    </v-btn>
                  </v-flex>
                </v-layout>
                </form>
          </div>
        </v-flex>
      </v-layout>
      <v-layout v-if="group.subscription.status !== 'active' && group.subscription.status !== 'pastDue'">
        <v-flex xs12 mt-4>
          <div class="app-panel white py-4" :class="{'px-4' : $vuetify.breakpoint.xsOnly, 'px-5' : !$vuetify.breakpoint.xsOnly}">
              <v-layout row wrap pb-3>
                <v-flex xs12>
                  <span class="subheading">Your subscription</span>
                </v-flex>
              </v-layout>
                  <stripe-pricing-table
                  :pricing-table-id='stripe_pricing_table_id'
                  :publishable-key='stripe_key'
                  :client-reference-id='user.group'
                  :customer-email='email'
                  >
                  </stripe-pricing-table>
                  <p class="caption">Prices excluding VAT at 20%</p>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import { formatDate } from '@/components/Mixins/formatDate'

export default {
  mixins: [formatDate],
  data () {
    return {
      user: this.$store.getters.user,
      complete: false,
      stripe_key: process.env.VUE_APP_STRIPEPUBKEY,
      stripe_pricing_table_id: process.env.VUE_APP_STRIPEPRICINGTABLEID,
      app_environment: process.env.VUE_APP_ENVIRONMENT,
      email: this.$store.getters.user.email,
      password: ''
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    group () {
      return this.$store.getters.group
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>
<style lang="scss" >
.flcaps {
  text-transform: capitalize;
  margin-left:4px;
}
</style>
